<template lang='pug'>
  div
    transition(name='slide-fade-down' mode='out-in' appear)
      MapToolsGeneric(ref='toolsGeneric' verticalType='crm' @updateFilter='updateFilter' @controlLeyenda="controlLeyenda")
    LegendMapIcon(:datosLegend='datosPopup' ref='LegendIcon' @open='open=true')
    transition(name='fadeSlide' appear)
      PanelDashboard(ref="panelDashboard")
        VerticalGeneric(
          slot="container"
          ref='verticalGeneric'
          @updateKpiGeneric='updateKpiGeneric'
          @setPopupParking='setPopupParking'
          verticalType='CRM')
        div.sc-dashboard__kpis__content(loading-background="rgba(0, 0, 0, 0)")
        MapZoomParks.panel-dashboard__tools.panel-dashboard__tools--bottom-left-out(
          slot="tools"
          ref='mapZoom')
        SearchMap.panel-dashboard__search.panel-dashboard__search--top-left-out(
          slot="search"
          ref="mapSearch"
        )
</template>

<script>
import CRMMain from '@/views/CRMMain'
import MapZoomParks from '@/components/MapZoomParks'
import PanelDashboard from '@/components/PanelDashboard'
import MapToolsGeneric from '@/components/MapToolsGeneric'
import VerticalGeneric from '@/views/VerticalGeneric'
import PopupBus from '@/components/PopupBus'
import LegendMapIcon from '@/components/LegendMapIcon'
import SearchMap from '@/components/SearchMap'

import jsonGisCitizen from '@/moks/las_palmas/crm/gisCitizen'
import jsonGisCitizenGlobal from '@/moks/las_palmas/crm/gisCitizenGlobal'
import jsonGisComplaints from '@/moks/las_palmas/crm/gisComplaints'
import jsonGisComplaintsPoints from '@/moks/las_palmas/crm/gisComplaintsPoints'
import jsonGisConsultations from '@/moks/las_palmas/crm/gisConsultations'
import jsonGisDamage from '@/moks/las_palmas/crm/gisDamage'

export default {
  name: 'CRMDashboard',
  data () {
    return {
      mapLoad: false,
      /**  Data para las respuestas de los servicios de CRM */
      datosFinal: [],
      datosPopupBus: [],
      opened: false,
      dataSolicitations: null,
      verticalTabSelected: 'tramites',
      gisSolicitations: undefined,
      gisConsultations: undefined,
      gisDamage: undefined,
      gisComplaints: undefined,
      gisComplaintsNumber: undefined,
      verticalTabs: [{
        value: 'tramites',
        label: 'Transactions'
      },
      {
        value: 'ciudadanos',
        label: 'Citizens'
      },
      {
        value: 'alertas',
        label: 'Alert'
      }],
      inputActive: undefined,
      inputRelaci: undefined,
      filterActive: undefined,
      datosLegend: [],
      datosPopup: [],
      tabsVertical: 'CRM',
      listCRM: {
        CRM: {
          name: 'CRM',
          value: 'CRM',
          label: 'CRM',
          breadcumb: 'CRM',
          listCategory: [{
            label: 'heat map',
            options: [ {
              value: 'dataSourceAll',
              label: 'All',
              show: true
            }, {
              value: 'dataSourceSolicitations',
              label: 'Solicitations',
              show: false
            }, {
              value: 'dataSourceConsultations',
              label: 'Consultations',
              show: false
            }, {
              value: 'dataSourceComplaints',
              label: 'Complaints',
              show: false
            }, {
              value: 'dataSourceDamage',
              label: 'Damage',
              show: false
            }]
          }, {
            label: 'Base map',
            options: [{
              value: 'dataSourceNumComplaints',
              label: 'Nº Complaints',
              show: false
            }]
          }],
          listCategorySelected: 'dataSourceAll',
          legend: [
            {
              label: 'Meteorología',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_weather_green.svg',
              type: 'point'
            },
            {
              label: 'Calidad del aire',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_airQuality_blue.svg',
              type: 'point'
            },
            {
              label: 'Alérgenos',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_allergen_violet.svg',
              type: 'point'
            },
            {
              label: 'Nivel de ruido',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_noise_pink.svg',
              type: 'point'
            }
          ]
        }
      },
      dataParkingPanels2: {},
      dataParkingCurrent: {}
    }
  },
  methods: {
    controlLeyenda (categoryInput) {
      if (categoryInput !== 'dataSourceNumComplaints') {
        this.dataLegend(categoryInput)
      } else {
        this.dataQuejas(categoryInput)
      }
    },
    init (categoryInput) {
      // const component = this
      var data = null
      let mapsHeatArray = document.getElementById('dataIframe').contentWindow.viewer.imageryLayers._layers
      // iniciar Gis de filtro de todos
      if (categoryInput !== 'dataSourceNumComplaints') {
        this.dataLegend(categoryInput)
      } else {
        this.dataQuejas(categoryInput)
      }
      switch (categoryInput) {
        case 'dataSourceAll':
          if (mapsHeatArray.length > 1) {
            this.$refs.crm.loadDataFilterShow(categoryInput)
            this.$refs.crm.loadDataFilter(categoryInput)
          } else {
            // hacer peticion
            // console.log('al cargar---------->', categoryInput);
            // data = ['citizenGlobal', 'UPDATE_CITIZENS_GLOBAL_GIS']
            // this.$store.dispatch('getCRMGisData', data)

            // import jsonGisCitizen from '@/moks/las_palmas/crm/gisCitizen'
            // import jsonGisCitizenGlobal from '@/moks/las_palmas/crm/gisCitizenGlobal'
            // import jsonGisComplaints from '@/moks/las_palmas/crm/gisComplaints'
            // import jsonGisComplaintsPoints from '@/moks/las_palmas/crm/gisComplaintsPoints'
            // import jsonGisConsultations from '@/moks/las_palmas/crm/gisConsultations'
            // import jsonGisDamage from '@/moks/las_palmas/crm/gisDamage'
            this.dataCitizens = jsonGisCitizenGlobal
            this.dataCitizens.name = 'dataSourceAll'
            this.dataCitizens.subtype = 'citizen'
            this.myTimerHeatMapGlobal(jsonGisCitizenGlobal)
          }
          break
        case 'dataSourceSolicitations':
          this.$refs.crm.loadDataFilter(categoryInput)
          this.$refs.crm.loadDataFilterShow(categoryInput)
          if (this.gisSolicitations !== categoryInput) {
            this.gisSolicitations = categoryInput
            data = ['solicitations', 'UPDATE_SOLICITATIONS_GIS']
            this.$store.dispatch('getCRMGisData', data)
          }
          // component.$refs.crm.loadDataFilter()
          // document.getElementById('dataIframe').contentWindow.showHideLayerByLayerName('showLayer', 'dataSourceSolicitations')
          break
        case 'dataSourceConsultations':
          this.$refs.crm.loadDataFilter(categoryInput)
          this.$refs.crm.loadDataFilterShow(categoryInput)
          if (this.gisConsultations !== categoryInput) {
            this.gisConsultations = categoryInput
            data = ['consultations', 'UPDATE_CONSULTATIONS_GIS']
            this.$store.dispatch('getCRMGisData', data)
          }
          break
        // document.getElementById('dataIframe').contentWindow.showHideLayerByLayerName('showLayer', 'dataSourcesConsultations')
        case 'dataSourceDamage':
          this.$refs.crm.loadDataFilter(categoryInput)
          this.$refs.crm.loadDataFilterShow(categoryInput)
          if (this.gisDamage !== categoryInput) {
            this.gisDamage = categoryInput
            data = ['damage', 'UPDATE_DAMAGE_GIS']
            this.$store.dispatch('getCRMGisData', data)
          }
          // document.getElementById('dataIframe').contentWindow.showHideLayerByLayerName('showLayer', 'dataSourcesDamage')
          break
        case 'dataSourceComplaints':
          this.$refs.crm.loadDataFilter(categoryInput)
          this.$refs.crm.loadDataFilterShow(categoryInput)
          if (this.gisComplaints !== categoryInput) {
            this.gisComplaints = categoryInput
            data = ['complaints', 'UPDATE_COMPLAINTS_GIS']
            this.$store.dispatch('getCRMGisData', data)
          }
          // document.getElementById('dataIframe').contentWindow.showHideLayerByLayerName('showLayer', 'dataSourcesDamage')
          break
        case 'dataSourceNumComplaints':
          this.$refs.crm.loadDataFilter(categoryInput)
          this.$refs.crm.loadDataFilterShow(categoryInput)
          if (this.gisComplaintsNumber !== categoryInput) {
            this.gisComplaintsNumber = categoryInput
            data = ['complaints', 'UPDATE_COMPLAINTS_NUM_GIS']
            this.$store.dispatch('getCRMGisData', data)
          }
          this.$refs.verticalGeneric2.updateKpisType('dataSourceComplaints')
          break
      }
    },
    loadDataFilter () {
      const component = this
      component.$refs.toolsGeneric.loadDataFilter(component.listCRM[component.tabsVertical].listCategorySelected)
      component.$refs.toolsGeneric.loadDataFilterShow(component.listCRM[component.tabsVertical].listCategorySelected)
    },
    init2 () {
      const vm = this
      var myLoadMap = () => {
        let encontrado = false
        if (vm.mapLoad === true) {
          document.getElementById('dataIframe').contentWindow.mapClear()
          let selectArray = vm.listCRM[vm.tabsVertical].listCategory
          selectArray.forEach(elem => {
            elem.options.forEach(op => {
              document.getElementById('dataIframe').contentWindow.viewer.dataSources._dataSources
                .filter((data) => data._name.name === op.value)
                .map((valor) => {
                  valor.show = true
                  encontrado = true
                  return valor
                })
            })
            // 'dataSourceSensorZones', 'dataSourceParking', 'dataSourcePanelParking'
          })
          if (!encontrado) {
            vm.myTimerHeatMapGlobal(jsonGisCitizenGlobal)
            vm.myTimerHeatMapGlobal(jsonGisCitizen)
            vm.myTimerHeatMapGlobal(jsonGisComplaints)
            vm.myTimerHeatMapGlobal(jsonGisConsultations)
            vm.myTimerHeatMapGlobal(jsonGisDamage)
            vm.myTimerComplaints(jsonGisComplaintsPoints)
          }
          vm.controlPage()
          clearInterval(myLoadMapElem)
        }
      }
      var myLoadMapElem = setInterval(myLoadMap, 500)
    },
    controlPage () {
      const component = this
      component.cleanAndLoadDataGis()
    },
    dataLegend (categoryInput) {
      // console.log('Datos legend----------------------->', this.datosPopup);
      //  this.datosPopup = []
      var obj = {}
      let fil = categoryInput.replace(/datasource/gi, '')
      if (fil !== 'All') {
        switch (fil) {
          case 'Solicitations':
            fil = 'Solicitudes'
            break
          case 'Consultations':
            fil = 'Consultas'
            break
          case 'Complaints':
            fil = 'Quejas'
            break
          case 'Damage':
            fil = 'Averias'
            break
        }
      } else {
        fil = ''
      }
      obj.name = 'Leyenda'
      obj.cat = 'mapHot'
      obj.value1 = '+500 ' + fil
      obj.value2 = '200/500 ' + fil
      obj.value3 = '50/200 ' + fil
      obj.value4 = '0/50 ' + fil
      this.datosPopup = obj
      return this.datosPopup
    },
    dataQuejas (categoryInput) {
      this.datosPopup = []
      let obj = {}
      obj.name = 'Leyenda'
      obj.img = 'Quejas'
      obj.ico = 'complaint'
      obj.primary = 'primary'
      obj.textColorPrimary = 'Adecuado'
      obj.medium = 'medium'
      obj.textColorMedium = 'Alerta nivel medio'
      obj.alert = 'alert'
      obj.textColorAlert = 'Alerta nivel alto'
      obj.component = 'CRM'
      this.datosPopup = obj
      return this.datosPopup
    },
    setMapLoad () {
      this.mapLoad = true
      // console.log(this.$refs.mapSearch.changeBasemap())
    },
    changeCategory (category) {
      this.$emit('changeCategory', category)
    },
    changeSelectedKpi (val) {
      this.$emit('changeSelectedKpi', val)
      this.$refs.crm.updateControlSelected(val)
    },
    getStation (val) {
      this.$emit('getStation', val)
    },
    updateFilter (category, categorySelected) {
      this.$refs.verticalGeneric.updateKpisCRM(category, this.tabsVertical)
    },
    setCategoryFilter (inputActive, inputRelaci) {
      // console.log('input Activooo---->', inputActive, 'input relacionado---->', inputRelaci);
      // actulizar los filtros
      this.inputRelaci = inputRelaci
      this.inputActive = inputActive
      // Mandar al filtro el activo
      if (typeof this.inputActive === 'object') {
        this.filterActive = true
      } else {
        if (this.inputActive === 'dataSourceSolicitations') {
          this.filterActive = true
        } else {
          this.filterActive = false
        }
      }
    },
    cleanAndLoadDataGis () {
      const component = this
      var category = []
      var categorySelected = []
      var myLoadMap = () => {
        if (component.mapLoad === true && component.$refs.toolsGeneric !== undefined) {
          document.getElementById('dataIframe').contentWindow.mapClear()
          category = component.listCRM[component.tabsVertical].listCategory
          categorySelected = component.listCRM[component.tabsVertical].listCategorySelected
          component.$refs.toolsGeneric.setToolsGeneric(
            category,
            categorySelected
          )
          component.loadDataFilter()
          component.controlLeyenda(categorySelected)
          // component.$refs.verticalGeneric.updateKpis(categorySelected, component.tabsVertical)
          component.$refs.verticalGeneric.updateKpisCRM(categorySelected, component.tabsVertical)
          clearInterval(myLoadMapElem)
        }
      }
      var myLoadMapElem = setInterval(myLoadMap, 500)
    },
    controlCollapsePanel (open) {
      // if(this.$refs.panelDashboard) {
      this.$refs.panelDashboard.collapsePanel(open)
      // }
    },
    myTimerHeatMapGlobal (val) {
      // const component = this
      // const simb = 'img/icon_float_blue.svg'
      // const simbSelect = 'img/icon_float_white.svg'
      // const simbIsolated = 'ods-icon-icon_floats_isolated'
      // console.log('val mapa calor', val);
      document.getElementById('dataIframe').contentWindow.createHeatmap(
        // VAL---> valores de cada peticion
        val,
        'color',
        [
          'weight', // [0]
          0, // minIterationValue [1]
          1, // maxIterationValue [2]
          150, // searchRadius * [3]
          0.2, // minOpacity * [4]
          0.6, // maxOpacity * [5]
          0.99, // blur * [6]
          {
            '.2': '#522FDE',
            '.4': '#2FCFDE',
            '.6': '#F9F22F',
            '.8': '#DE2F2F'
          }
        ],
        'showLayer'
      )
      // console.log('Valor---->', val.name, 'mapas--_>', mapsHeatArray[1]._imageryProvider.name.layerName);
      // console.log(document.getElementById('dataIframe').contentWindow.viewer.imageryLayers._layers[1].show);
      // -----> ejemplo para ocultar mapas de calor
      // setTimeout(function () {
      //   console.log(val.name,'<---nombre---', document.getElementById('dataIframe').contentWindow.viewer.imageryLayers._layers[1]);
      //   document.getElementById('dataIframe').contentWindow.showHideLayerByLayerName('hideLayer', val.name)
      // }, 3000);
    },
    myTimerComplaints (val) {
      // const component = this
      // Array de todos los mapas
      let arrayMap = document.getElementById('dataIframe').contentWindow.viewer.dataSources._dataSources
      // console.log(arrayMap)
      const simb = 'img/icon_complaint_blue.svg'
      const simbSelected = 'img/icon_complaint_selected.svg'
      const simbIsolated = 'img/icon_complaint_red.svg'
      /** Se generan las entidades de tipo punto de los parques */
      // console.log('val numerooooos---->',val);
      document.getElementById('dataIframe').contentWindow.createLayer(
        // val json y todos los datos de ese dataSource
        val,
        // vertical name crm
        'crm',
        'point',
        'entity',
        'billboard',
        simb,
        simbSelected,
        simbIsolated,
        0.8
      )
      if (arrayMap) {
        if (arrayMap.length > 0) {
          arrayMap[1].show = true
        }
      }
      // console.log('mapas---->', arrayMap[0].name.name);
      // 10 radio en px
      // 2 numero de iconos necesarios
      // numero maximo agrupados
      // -- nomre del data dataSource y ruta de icono
      // document.getElementById('dataIframe').contentWindow.enableClustering('dataSourceNumComplaints', 'img/icon_cluster_blue.svg', 10, 2, 20)
      /** Este elemento aparece cargado inicialmente */
      // component.$refs.parkTools.filterInitial()
    },
    updateKpiGeneric () {
      const component = this
      // var category, categorySelected
      var categorySelected
      // category = component.$refs.toolsGeneric.getDataCategory()
      categorySelected = component.$refs.toolsGeneric.getCaterogySelected()
      component.$refs.verticalGeneric.updateKpis(categorySelected)
      // console.log('dashboard--> select dias----', component.kpisCurrentFilter);
    },
    updatePopup (data) {
      this.datosFinal = data
    },
    filterAc (elment) {
      // console.log('asdfasd');
      this.filterActive = elment
    },
    setPopupParking (val, data, type, currentKpi) {
      this.$refs.legendMap.open = this.$refs.legendMap.data = true
      this.openedParking = val
      this.dataParkingPanels = []
      this.dataParkingPanels = data
      this.dataParkingPanels2 = data
      this.dataParkingCurrent = currentKpi
    }
  },
  beforeDestroy () {
    document.getElementById('dataIframe').contentWindow.mapClear()
  },
  mounted () {
    // this.$store.dispatch('getAllStationsCRM')
    this.init2()
    // this.$refs.verticalGeneric2.$refs.kpiVertical.kpiFilterSelected = ['all']
    // console.log(this.$refs.LegendIcon);
    // console.log(this.$route);
  },
  created () {
    this.$emit('controlLoad')
  },
  components: {
    CRMMain,
    MapZoomParks,
    PanelDashboard,
    MapToolsGeneric,
    VerticalGeneric,
    PopupBus,
    LegendMapIcon,
    SearchMap
  }
}
</script>

<style lang='scss' scoped>
/deep/ .ods-tabs {
  z-index: 9999999;
  &__nav-wrap.is-scrollable {
    padding: 0 rem(48);
    width: 88%;
  }
  &__header {
    box-sizing: border-box;
    background: $--color-white;
    margin-bottom: 0;
    // min-height: rem(64);
    padding: rem(8) rem(32) 0 rem(32);
    z-index: 2;
  }
  &__item {
    padding: rem(16) rem(24);
  }
  &__content{
    /* padding: rem(0) rem(30); */
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CRMDashboard.vue